import { render, staticRenderFns } from "./relationsLegend.vue?vue&type=template&id=0b828740&scoped=true&"
import script from "./relationsLegend.vue?vue&type=script&lang=js&"
export * from "./relationsLegend.vue?vue&type=script&lang=js&"
import style0 from "./relationsLegend.vue?vue&type=style&index=0&id=0b828740&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b828740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b828740')) {
      api.createRecord('0b828740', component.options)
    } else {
      api.reload('0b828740', component.options)
    }
    module.hot.accept("./relationsLegend.vue?vue&type=template&id=0b828740&scoped=true&", function () {
      api.rerender('0b828740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/relationsNetwork/relationsLegend.vue"
export default component.exports